import React, { useState, useEffect, useMemo, useRef } from 'react';

import './DemoSlider.css';

function DemoSlider({ slides, seed }) {
  const [{ slide, limiter }, setState] = useState({
    slide: 0,
    limiter: -1,
  });
  const endSlide = slides.length; // like iterator end, virtual slide
  const timer = useRef(null);
  useEffect(() => {
    setState({ slide: 0, limiter: -1 });
  }, [seed]);

  const { name, text } = (slides || [])[slide] || { name: 'Not defined', text: 'Please press Refresh demo' };

  const startAnimation = () => {
    if (timer.current) {
      return;
    }

    timer.current = setInterval(() => {
      setState((prevState) => {
        if (prevState.limiter >= text.length) {
          clearInterval(timer.current);
          timer.current = null;
          return {
            ...prevState,
            limiter: -1,
          };
        }

        return {
          ...prevState,
          limiter: prevState.limiter + 1,
        };
      });
    }, 35);
  };

  const nextSlide = (e) => {
    e.preventDefault();

    if (timer.current) {
      clearInterval(timer.current);
      setState((prevState) => {
        return {
          ...prevState,
          limiter: -1,
        };
      });
      timer.current = null;
      return;
    }

    setState((prevValue) => {
      if (prevValue.slide + 1 === endSlide) {
        return prevValue;
      }

      return {
        ...prevValue,
        limiter: 0,
        slide: prevValue.slide + 1,
      };
    });
  };

  const prevSlide = (e) => {
    e.preventDefault();

    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }

    setState((prevValue) => {
      if (prevValue.slide === 0) {
        return {
          ...prevValue,
          limiter: -1,
        };
      }

      return {
        ...prevValue,
        limiter: -1,
        slide: prevValue.slide - 1,
      };
    });
  };

  let prevSlideRef = useRef(0);
  useEffect(() => {
    if (slide <= prevSlideRef.current) {
      prevSlideRef.current = slide;
      return;
    }

    startAnimation();

    prevSlideRef.current = slide;
  }, [slide]);


  return (
    <div className="slide-wrapper">
      <div className="slide-back-row" onClick={prevSlide}>Back</div>
      <div className="reply-wrapper" onClick={nextSlide}>
        <div className="reply-header">{name}</div>
        <div className="reply-body">{limiter === -1 ? text : text.substr(0, limiter)}</div>
      </div>
    </div>
  );
}

export default DemoSlider;
